var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistorico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "historico",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.727,
    height: 25.727,
    viewBox: "0 0 25.727 25.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1030_",
    d: "M22.982,4.921h.795a.5.5,0,0,0,0-1H21.869a.5.5,0,0,0-.5.5V6.327a.5.5,0,1,0,1,0V5.775A11.859,11.859,0,1,1,12.864,1a12.038,12.038,0,0,1,1.447.087.5.5,0,0,0,.121-1A13.046,13.046,0,0,0,12.864,0a12.864,12.864,0,0,0-9.1,21.959A12.863,12.863,0,0,0,22.982,4.921Z",
    transform: "translate(0 0)",
    fill: "#7d0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1029_",
    d: "M67.353,69.49a.5.5,0,0,0-.693.156,9.588,9.588,0,1,0,3-3,.5.5,0,1,0,.535.85,8.588,8.588,0,1,1-1.5,13.342,8.642,8.642,0,0,1-1.189-10.659A.5.5,0,0,0,67.353,69.49Z",
    transform: "translate(-61.906 -61.907)",
    fill: "#7d0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1028_",
    d: "M376.671,247.334h.619a.5.5,0,1,0,0-1h-.619a.5.5,0,0,0,0,1Z",
    transform: "translate(-357.28 -233.96)",
    fill: "#7d0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1004_",
    d: "M103.835,246.508a.5.5,0,0,0,.5.5h.619a.5.5,0,0,0,0-1h-.619A.5.5,0,0,0,103.835,246.508Z",
    transform: "translate(-98.621 -233.653)",
    fill: "#7d0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1001_",
    d: "M247.334,104.956v-.619a.5.5,0,1,0-1,0v.619a.5.5,0,1,0,1,0Z",
    transform: "translate(-233.96 -98.621)",
    fill: "#7d0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1415_",
    d: "M246.006,376.671v.619a.5.5,0,1,0,1,0v-.619a.5.5,0,0,0-1,0Z",
    transform: "translate(-233.653 -357.28)",
    fill: "#7d0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_996_",
    d: "M189.83,156.36a.5.5,0,0,0-.71.71l1.7,1.7a1.73,1.73,0,1,0,3.051,0l3.434-3.434a.5.5,0,1,0-.71-.71l-3.434,3.434a1.726,1.726,0,0,0-1.63,0Zm3.243,3.227a.726.726,0,1,1-.726-.726A.726.726,0,0,1,193.072,159.587Z",
    transform: "translate(-179.483 -146.724)",
    fill: "#7d0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_980_",
    d: "M119.035,119.035a.5.5,0,1,0-.355.147A.5.5,0,0,0,119.035,119.035Z",
    transform: "translate(-112.244 -112.244)",
    fill: "#7d0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_979_",
    d: "M315.94,10.882a.5.5,0,1,0-.355-.147A.5.5,0,0,0,315.94,10.882Z",
    transform: "translate(-299.598 -9.382)",
    fill: "#7d0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorico);
export default __webpack_public_path__ + "static/media/historico.eda5866a244466d9fe3db627945733cb.svg";
export { ForwardRef as ReactComponent };